"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//https://libzl.zlthunder.net/v3/version/<version>/libzl.js.sri
exports.LibZLVersionHashes = {
    "3.162.2": "sha512-1YuFzLJUWY11JKYyjvdix3t1T3yewR3i4mClWt36csYdxsZnPCnG7De6IqUenBLxUmQPgl8GAlNRibXKvz4efA==",
    "3.209.3": "sha512-wWuKaDl0mMDgtMGxRqvSmy8FPRpxJbkB0DBqsSW+0+vkK5+zog5qV8+qkMm5VAslaYshwJTciDnE6ssdx2jHEA==",
    "3.215.0": "sha512-DqJCePd+G2cALqs4L8VXgxbIEL9/2nVoFz5nXdRrVq66xg5AgYF1vmNY9KzCcA8VJ9B9OsYy4g9QaPqWcmCN3Q==",
    "3.217.7": "sha512-e4qXJzpjon6KlODE24pGiMdASfS8aoVJfV9P3g7MBALwABuX1l/mhX1tkmdFlogdMugpwTNFkNRSEFBBk2UqLQ==",
    "3.218.20": "sha512-iqjaUv3WkSwRx05QWksBzFyLeu86XpgKVSYwOs3eQ3vJMfyUnFD+vymS87qkiPfub4/5vOsjo91iyZ8cCpgSkw==",
    "3.220.5": "sha512-pmHudeZXcBrWTWEPdILT/LxC/H76p6o/JVaJE73Yh7Iw3vsFHlhMzqW5nTX49/hEo17HlGnW0WQjfttIpKonnw==",
    "3.220.6": "sha512-3POTVssXGGYig451QXsGSc/ntEmw6HdLnKRMBUeEdvuR3TCpEH+EXwqJQMerc1CYvq+juu8a5EjcHM/MfmMxCA==",
    "3.223.8": "sha512-TdHcodxFd73kHV37AvwA3YrqJWbRyha24Q7fmw4jKst5HmPeu6/CEcDtVwgwF+s9i+Y8S6bS5VsGZuIVbNncsQ=="
};
exports.LibZLStreams = {
    dev: "3.223.8",
    prelive: "3.223.8",
    live: "3.223.8"
};
//# sourceMappingURL=LibZLVersions.js.map